export interface IDocument {
  _id?: string;
  name: string;
  description?: string;
  url: string;
  type: ETypeDocument;
  slug?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum ETypeDocument {
  CONTACT = 'CONTACT',
  CERTIFICATE = 'CERTIFICATE',
}
